import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_Symbol.js
// module id = 355
// module chunks = 0